import React, { useState } from 'react';
import { FiFilter, FiCalendar, FiCheck } from 'react-icons/fi';

const FilterBar = ({ onApplyFilters }) => {
  const [dateFilter, setDateFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState([]);
  
  const handleStatusChange = (status) => {
    if (statusFilter.includes(status)) {
      const newFilters = statusFilter.filter(s => s !== status);
      setStatusFilter(newFilters);
      applyFilters(dateFilter, newFilters);
    } else {
      const newFilters = [...statusFilter, status];
      setStatusFilter(newFilters);
      applyFilters(dateFilter, newFilters);
    }
  };
  
  const handleDateChange = (value) => {
    setDateFilter(value);
    applyFilters(value, statusFilter);
  };
  
  const applyFilters = (date, status) => {
    onApplyFilters({
      dateFilter: date,
      statusFilter: status
    });
  };
  
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-6 flex flex-wrap items-center gap-4">
      <div className="flex items-center">
        <FiFilter className="h-5 w-5 text-gray-500 mr-2" />
        <span className="font-medium text-gray-700">Filters:</span>
      </div>
      
      <div className="flex items-center">
        <FiCalendar className="h-4 w-4 text-gray-500 mr-2" />
        <span className="text-sm text-gray-700 mr-2">Date:</span>
        <select
          value={dateFilter}
          onChange={(e) => handleDateChange(e.target.value)}
          className="text-sm border-gray-300 rounded-md shadow-sm focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50"
        >
          <option value="all">All time</option>
          <option value="7days">Last 7 days</option>
          <option value="30days">Last 30 days</option>
          <option value="90days">Last 90 days</option>
        </select>
      </div>
      
      <div className="flex items-center flex-wrap gap-2" role="group" aria-label="Filter by status">
        <span className="text-sm text-gray-700 mr-2" id="status-filter-label">Status:</span>
        {['applied', 'interviewing', 'offered', 'rejected'].map((status) => {
          const isActive = statusFilter.includes(status);
          return (
            <button
              key={status}
              onClick={() => handleStatusChange(status)}
              aria-pressed={isActive}
              aria-describedby="status-filter-label"
              aria-label={`Filter by ${status}`}
              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                isActive
                  ? 'bg-primary-100 text-primary-800 border-primary-300'
                  : 'bg-gray-100 text-gray-800 border-gray-200'
              } border`}
            >
              {isActive && <FiCheck className="mr-1 h-3 w-3" aria-hidden="true" />}
              <span className="capitalize">{status}</span>
            </button>
          );
        })}
      </div>
      
      {(dateFilter !== 'all' || statusFilter.length > 0) && (
        <button
          onClick={() => {
            setDateFilter('all');
            setStatusFilter([]);
            applyFilters('all', []);
          }}
          className="text-xs text-primary-600 hover:text-primary-800 ml-auto"
          aria-label="Clear all filters"
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default FilterBar;